import { render, staticRenderFns } from "./OSconstitute.vue?vue&type=template&id=386c8a78&scoped=true&"
import script from "./OSconstitute.vue?vue&type=script&lang=js&"
export * from "./OSconstitute.vue?vue&type=script&lang=js&"
import style0 from "./OSconstitute.vue?vue&type=style&index=0&id=386c8a78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386c8a78",
  null
  
)

export default component.exports